const AutosuggestStyle = {
  container: {
    position: 'relative',
  },
  input: {
    paddingRight: '28px !important',
    paddingLeft: '12px !important',
    borderRadius: '15px !important',
    backgroundColor: '#f4f4f4 !important',
  },
  suggestionsContainer: {
    background: 'transparent',
    position: 'absolute',
    top: '100%',
    width: '100%',
    borderRadius: '4px',
    marginTop: '6px',
    paddingBottom: '4px',
    paddingTop: '4px',
  },
  suggestionsContainerOpen: {
    background: 'white',
    boxShadow:
      '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
  },
  suggestion: {
    padding: '8px 12px',
    cursor: 'pointer',
    fontWeight: 'normal',
  },
  suggestionHighlighted: {
    background: ({ theme }) => theme?.colors?.horizon || '#e6e6e6',
  },
};

export default AutosuggestStyle;
